import { z } from 'zod';
import { ROLES } from '../roles.js';
/**
 * Vertrag zwischen Frontend und API. Beide Seiten leiten ihre Typen hieraus
 * ab — es gibt keine zweite, handgepflegte Typdefinition im Frontend.
 */
export const loginRequest = z.object({
    email: z.string().email('Bitte eine gueltige E-Mail-Adresse eingeben'),
    password: z.string().min(1, 'Passwort fehlt'),
});
export const currentUser = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    name: z.string().nullable(),
    tenantId: z.string().uuid(),
    role: z.enum(ROLES),
    permissions: z.array(z.string()),
    lastLoginAt: z.string().datetime().nullable(),
});
export const loginResponse = z.object({
    user: currentUser,
});
export const changePasswordRequest = z
    .object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(12, 'Das neue Passwort muss mindestens 12 Zeichen lang sein'),
    confirmPassword: z.string(),
})
    .refine((d) => d.newPassword === d.confirmPassword, {
    message: 'Die Passwoerter stimmen nicht ueberein',
    path: ['confirmPassword'],
});
/** Einheitliches Fehlerformat aller API-Antworten. */
export const apiError = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        /** Feldbezogene Fehler fuer Formulare. */
        fields: z.record(z.string()).optional(),
    }),
});
//# sourceMappingURL=auth.js.map